import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuthRequest } from "request/request";
import { toast } from "react-toastify";

export const getStudentParent = createAsyncThunk(
  "parent/getStudentParent",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      let url = `student/v1/student-parent`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        // dispatch(getStudentsAttendance(currentGroup))
        // toast.success("Иҷро шуд!");

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const setStudentAbsent = createAsyncThunk(
  "teacher/setStudentAbsent",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      let url = `student/v1/student-parent`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        // dispatch(getStudentsAttendance(currentGroup))
        // toast.success("Иҷро шуд!");

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentDiary = createAsyncThunk(
  "parent/getStudentDiary",
  async (
    { group_id, student_id, start_date, end_date },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let url = `schedule/v1/student-diary?group_id=${group_id}&student_id=${student_id}&start_date=${start_date}&end_date=${end_date}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentSchedule = createAsyncThunk(
  "parent/getStudentSchedule",
  async (
    { student_id, start_date, end_date },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let url = `schedule/v1/student-schedule?student_id=${student_id}&start_date=${start_date}&end_date=${end_date}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAttendanceScheduleDates = createAsyncThunk(
  "parent/getAttendanceScheduleDates",
  async ({ semester_property_id, student_id }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/attendance-schedule-dates?student_id=${student_id}&semester_property_id=${semester_property_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSemesterDataByGroupId = createAsyncThunk(
  "parent/getSemesterDataByGroupId",
  async ({ group_id }, { rejectWithValue }) => {
    try {
      let url = `education/v1/semester-data-by-group-id?group_id=${group_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentSubjectMarks = createAsyncThunk(
  "parent/getStudentSubjectMarks",
  async ({ student_id, semester_property_id }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/student-subjects-marks?student_id=${student_id}&semester_property_id=${semester_property_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentControlByParent = createAsyncThunk(
  "admin/getStudentControlByParent",
  async ({ student_id, start_date, end_date }, { rejectWithValue }) => {
    try {
      let url = `student/v1/student-control-by-parent?student_id=${student_id}&start_date=${start_date}&end_date=${end_date}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
